import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

const SnackbarAlert = ({ ...props }) => {
  const { open, onClose, severity, message } = props;
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Snackbar open={open} autoHideDuration={4000} onClose={onClose}>
        <MuiAlert onClose={onClose} severity={severity}>
          {message}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

SnackbarAlert.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  severity: PropTypes.string,
  message: PropTypes.string,
};

export default SnackbarAlert;
